const TimeTracker = ({ compteur }) => {
    if (!compteur) return null; // Si aucune donnée, ne rien afficher

    // Transforme les minutes en format "1h30"
    const formatTime = (minutes) => {
        if (minutes === "Illimité") return "Illimité";
        const h = Math.floor(minutes / 60);
        const m = minutes % 60;
        return `${h}h${m.toString().padStart(2, '0')}`;
    };

    // Vérifie si une valeur est un nombre valide
    const isNumeric = (n) => !isNaN(parseFloat(n)) && isFinite(n);
    const ratio = Math.floor(parseFloat(compteur.ratio));  // Pourcentage arrondi

    // Couleur selon le pourcentage ou si le max est "Illimité"
    const getColorClass = () => {
        if (!isNumeric(compteur.max)) return "bg-mlime"; // Toujours vert si illimité
        if (ratio < 60) return "bg-mlime";
        if (ratio < 80) return "bg-orange-400";
        return "bg-red-500";
    };

    return (
        <div className="flex flex-col items-center gap-4 bg-gray-100 px-4 py-3 rounded-md">
            <h2 className=" font-semibold text-gray-700">Temps support technique</h2>
                <div className="w-3/4">
                    <div className=" relative bg-mlime bg-opacity-30 rounded-full overflow-hidden h-6 shadow-inner">
                        <div
                            className={`h-full ${getColorClass()} text-white text-sm flex items-center justify-center`}
                            style={{ width: `${ratio}%` }}
                        >
                            {ratio} %
                        </div>
                    </div>
                    <div className="text-center text-sm mt-1 text-gray-700">
                        {formatTime(compteur.compteur_temps)} /{" "}
                        {isNumeric(compteur.max) ? formatTime(compteur.max) : "Illimité"}
                    </div>
                </div>
        </div>
    );
};

export default TimeTracker;
